export default "__VITE_ASSET__e4983564__"